export const StyleFour = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1000 100"
            fill="none"
            preserveAspectRatio="none"
        >
            <path
                className="eb-shape-divider-fill"
                fill="#B843D6"
                d="M646.99 79.145C766.266 62.962 906.985 26.462 1000 0H0c211.255 131.265 460.086 104.501 646.99 79.145Z"
            />
        </svg>
    );
};
